import React from "react";
import { Radio } from "antd";
const WelcomeStep1 = ({ setPersona, persona }) => {
  return (
    <div className="welcome-modal-content">
      <div className="header-modal">
        Faisons connaissance{" "}
        <span role="img" aria-label="emoji">
          🙋‍♂️
        </span>{" "}
      </div>
      <div className="content-welcome-modal">
        <p>Avant de créer votre première page, dites-nous en plus sur vous.</p>
        <p>Parmi les propositions suivantes, laquelle vous décrit le mieux :</p>
        <div className="persona-welcome">
          <Radio.Group
            onChange={(e) => {
              setPersona(e.target.value);
            }}
            value={persona}
          >
            <Radio value="influenceur">Influenceur</Radio>
            <Radio value="agence">Agence</Radio>
            <Radio value="e-commerce">E-commerce</Radio>
            <Radio value="association">Association</Radio>
            <Radio value="entreprise-b2b">Entreprise B2B</Radio>
            <Radio value="autre">Autre</Radio>
          </Radio.Group>
        </div>
      </div>
    </div>
  );
};

export default WelcomeStep1;
